import {
  DocumentOrganizationKeys,
  FilterDocument,
  FilterOptionKeys,
  GroupByMode,
  SortingMode,
  Tag,
} from '@griply/types';

export const getDefaultFilterDocument = (tag?: Tag): FilterDocument => ({
  [DocumentOrganizationKeys.GroupByMode]: GroupByMode.Priority,
  [DocumentOrganizationKeys.SortingMode]: SortingMode.Custom,
  [DocumentOrganizationKeys.Filters]: {
    [FilterOptionKeys.Tag]: { include: [tag?.id ?? ''] },
  },
});
